// Registry of per-user OAuth providers reachable via the generic backend
// `/integrations/{provider}` routes. Adding a provider = one entry here (plus
// its backend catalog + OAuth config). Everything else in this module — the
// connect popup, the in-chat "Connect" banner, and the post-OAuth return
// handler — is provider-agnostic and reads from this map.

export interface OAuthProvider {
  /** Matches the backend `{provider}` path segment and the `connect_required` preflight signal. */
  id: string;
  /** Human label shown in the UI ("Connect {label}"). */
  label: string;
  /** Authorize-URL host allowlist — the connect flow refuses any other host. */
  authorizeHost: string;
  /** The `?<param>=connected|error` query the OAuth callback redirects back with. */
  returnParam: string;
}

export const OAUTH_PROVIDERS: Record<string, OAuthProvider> = {
  honeycomb: {
    id: 'honeycomb',
    label: 'Honeycomb',
    authorizeHost: 'adobe.okta.com',
    returnParam: 'honeycomb',
  },
};

export function getOAuthProvider(id: string): OAuthProvider | undefined {
  return OAUTH_PROVIDERS[id];
}

/** Find the provider whose `returnParam` is present in a URL query, if any. */
export function providerForReturnParams(params: URLSearchParams): { provider: OAuthProvider; outcome: string } | null {
  for (const provider of Object.values(OAUTH_PROVIDERS)) {
    const outcome = params.get(provider.returnParam);
    if (outcome === 'connected' || outcome === 'error') return { provider, outcome };
  }
  return null;
}
